import { css, styled } from 'styled-components';

import { Styled as ButtonStyled } from '../Button/styles';

type TextOverflowProps = {
  textOverflow?: boolean;
};

const TextOverflowPropsStyle = css<TextOverflowProps>(
  ({ textOverflow }) => `
    text-overflow: ${textOverflow ? 'ellipsis' : undefined};
    overflow-x: ${textOverflow ? 'hidden' : undefined};
    display: ${textOverflow ? 'inline-block' : undefined};
    white-space: ${textOverflow ? 'nowrap' : undefined};
  `,
);

const Anchor = styled.a<TextOverflowProps>`
  cursor: pointer;
  color: ${({ theme }) => theme.designTokens.anchorTextColor};
  text-decoration: ${({ theme }) => theme.designTokens.anchorTextDecoration};
  ${TextOverflowPropsStyle}
  &,
  &:hover,
  &:focus {
    outline: none;
  }
  &:hover {
    text-decoration: ${({ theme }) => theme.designTokens.anchorHoverTextDecoration};
  }
  &:focus {
    text-decoration: ${({ theme }) => theme.designTokens.anchorFocusTextDecoration};
    color: ${({ theme }) => theme.designTokens.anchorFocusTextColor};
  }
  /* stylelint-disable */
  ${ButtonStyled.Button} &,
  ${ButtonStyled.Button} &:hover,
  ${ButtonStyled.Button} &:focus {
    color: inherit;
    text-decoration: none;
  }
  /* stylelint-enable */
`;

export const Styled = {
  Anchor,
};
